import React from "react";

const CopySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M2.14286 4.07143V9.85714H7.92857V4.07143H2.14286ZM1.82143 3.42857H8.25C8.33525 3.42857 8.41701 3.46244 8.47728 3.52272C8.53756 3.583 8.57143 3.66475 8.57143 3.75V10.1786C8.57143 10.2638 8.53756 10.3456 8.47728 10.4059C8.41701 10.4661 8.33525 10.5 8.25 10.5H1.82143C1.73618 10.5 1.65442 10.4661 1.59414 10.4059C1.53386 10.3456 1.5 10.2638 1.5 10.1786V3.75C1.5 3.66475 1.53386 3.583 1.59414 3.52272C1.65442 3.46244 1.73618 3.42857 1.82143 3.42857ZM10.5 1.82143V8.89286C10.5 8.97811 10.4661 9.05986 10.4059 9.12014C10.3456 9.18042 10.2638 9.21429 10.1786 9.21429H9.21429V8.57143H9.85714V2.14286H4.71429V2.78571H4.07143V1.82143C4.07143 1.73618 4.10529 1.65442 4.16557 1.59414C4.22585 1.53386 4.30761 1.5 4.39286 1.5H10.1786C10.2638 1.5 10.3456 1.53386 10.4059 1.59414C10.4661 1.65442 10.5 1.73618 10.5 1.82143ZM3.42857 7.60714H6.64286V8.25H3.42857V7.60714ZM3.42857 5.67857H6.64286V6.32143H3.42857V5.67857Z"
        fill="#5F6368"
      />
    </svg>
  );
};

export default CopySvg;
